import { seoUrlPart } from '@ecg-marktplaats/aurora-js-formatters';

export default (urlPart: string): string => seoUrlPart(urlPart).toLowerCase();
